import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { UserService } from 'src/app/services/user/user.service';
import { UserIndicateds } from './../../../services/user/model/user-indicateds';

@Component({
  selector: 'app-modal-details-indicated',
  templateUrl: './modal-details-indicated.component.html',
  styleUrls: ['./modal-details-indicated.component.scss'],
})
export class ModalDetailsIndicatedComponent {
  public loading = true;
  public selectTabs = 'users';
  public userIndicateds: UserIndicateds;

  constructor(
    private loaderService: LoaderService,
    private modalCtrl: ModalController,
    private userService: UserService
  ) {}

  async ionViewWillEnter() {
    await this.loaderService.showLoader();
    this.loading = true;
    try {
      this.userIndicateds = await this.userService.getIndicatedsList();
    } catch (error) {
      console.error(error);
    } finally {
      await this.loaderService.hideLoader();
      this.loading = false;
    }
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }
}
